// export const getListedJobs = (jobData) => {
//   console.log(jobData);
//   const jobResult = {
//     id: jobData._id,
//     title: jobData?.jobTitle,
//     type: jobData?.jobType,
//     lga: jobData?.localGovernment,
//     state: jobData?.state,
//     work: jobData?.workType,
//     industry: jobData?.industry,
//     expires: new Date(jobData?.vacancyDuration).toLocaleDateString(),
//     online:
//       new Date(jobData?.vacancyDuration) < new Date().toLocaleDateString(),
//     status: [
//       {
//         key: "All Candidate",
//         value: jobData?.applications?.length,
//       },
//       {
//         key: "Short Listed",
//         value: jobData?.applications?.length,
//       },
//       {
//         key: "Scheduled for Interview",
//         value: jobData?.applications?.length,
//       },
//       {
//         key: "Hired",
//         value: jobData?.applications?.length,
//       },
//       {
//         key: "Rejected",
//         value: jobData?.applications?.length,
//       },
//     ],
//   };
//   return jobResult;
// };








export const getListedJobs = (jobData) => {
  console.log("Job Data:", jobData);
  console.log("Applications:", jobData?.applications); // Debug applications structure
  const jobResult = {
    id: jobData._id,
    title: jobData?.jobTitle,
    type: jobData?.jobType,
    lga: jobData?.localGovernment,
    state: jobData?.state,
    work: jobData?.workType,
    industry: jobData?.industry,
    expires: new Date(jobData?.vacancyDuration).toLocaleDateString(),
    online: new Date(jobData?.vacancyDuration) > new Date(), // True if vacancy is still active
    status: [
      {
        key: "All Candidate",
        value: jobData?.applications?.length || 0,
      },
      {
        key: "Short Listed",
        value: jobData?.applications?.filter(app => app.shortListed)?.length || 0,
      },
      {
        key: "Scheduled for Interview",
        value: jobData?.applications?.filter(app => app.scheduledForInterview)?.length || 0,
      },
      {
        key: "Hired",
        value: jobData?.applications?.filter(app => app.hired)?.length || 0,
      },
      {
        key: "Rejected",
        value: jobData?.applications?.filter(app => app.rejected)?.length || 0,
      },
    ],
  };
  return jobResult;
};